/**
 * 2019/1/10.
 * 作者:lzq
 *功能: 角色管理模块
 */
export default {
  $getway: 'sysapi',
  getRoleList: 'role/list',
  saveRole: 'role/save',
  getAllRoleList: 'role/selectAllRoleName',
  // deleteRole: 'role/delete',
  deleteRole: 'role/del',
  getAuthorityTree: 'authority/selectAuthorityTree',
  updateRoleStatus: 'role/open'
};
